<template>
<drawer :class="$style.drawer">
    <sidebar-links
        slot="body"
        :class="$style.sidebar_body"
        :items="items" />
</drawer>
</template>

<script>
import { mapGetters } from "vuex";
import Drawer from "@/components/mdc/Drawer.vue";
import SidebarLinks from "@/components/SidebarLinks.vue";
import {
    DEVELOPER_PROJECTS,
    DEVELOPER_PROJECT_DETAIL,
    DEVELOPER_PROJECT_REGISTER
} from "@/router/path";

export default {
    components: { Drawer, SidebarLinks },
    computed: {
        ...mapGetters(["hasProject", "approvedProjects", "myProjects"]),
        items() {
            const { hasProject, projectsLink } = this;
            return [
                {
                    text: this.$t("sidebar.project"),
                    to: DEVELOPER_PROJECTS,
                    exact: hasProject,
                    children: hasProject && projectsLink
                }
            ];
        },
        projectsLink() {
            const links = this.myProjects.map(({ name, id }) => ({
                text: name,
                to: `${DEVELOPER_PROJECT_DETAIL}/${id}`
            }));
            const { name } = this.$route;
            if (this.hasProject && name === "projectRegister") {
                links.push({
                    text: this.$t("sidebar.projectRegister"),
                    to: DEVELOPER_PROJECT_REGISTER
                });
            }
            return links;
        }
    }
};
</script>

<style lang="scss" module>
@use "@/assets/scss/sidebar_layout";
.drawer {
    width: 264px;
}
</style>
